// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"84":"9b0008ae","524":"2170a4aa"}[chunkId] || chunkId) + "." + {"84":"5e6afa478dbe8e8a","436":"f428a6f91a270fd9","524":"47f97b4a776f7cea","560":"1e910e6d7249d2ef","714":"8c89f0c07db3ce83"}[chunkId] + ".js";
};